<template>

    <div class="mt-3">
        <p class="text-sm font-medium text-right text-red-600"> * <span class="text-slate-600"> Required field</span>
        </p>
        <form>
            <ErrorSummary :response-status="responseStatus" />
            <div class="mt-6">
                <div class="">
                    <div class="grid grid-cols-4 gap-6 pb-8 mt-6">
                        <div class="col-span-4 sm:col-span-2">
                            <label class="block text-sm font-medium text-gray-700" for="selectedShow">Show/Project <span
                                    class="text-red-600">*</span></label>
                            <Combobox v-model="selectedShow" as="div" nullable>
                                <div class="relative mt-1">
                                    <ComboboxInput :display-value="displaySelectedShow"
                                                   id="selectedShow"
                                                   class="w-full py-2 pl-3 pr-10 bg-white border rounded-md shadow-sm border-clay-500 focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm"
                                        @change="getShows" />
                                    <ComboboxButton 
                                        class="absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden" aria-label="Expand Button">
                                        <ChevronDownIcon aria-hidden="true" class="w-5 h-5 text-gray-400" />
                                    </ComboboxButton>
                                    <ComboboxOptions
                                        class="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm">

                                        <ComboboxOption v-if="queryShow" v-slot="{ active, selected }"
                                            :value="queryShow" as="template">
                                            <li
                                                :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900']">
                                                <span :class="['block truncate', selected && 'font-semibold']">
                                                    Add "{{ query }}"
                                                </span>
                                                <span v-if="selected"
                                                    :class="['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600']">
                                                    <CheckIcon aria-hidden="true" class="w-5 h-5" />
                                                </span>
                                            </li>
                                        </ComboboxOption>
                                        <ComboboxOption v-for="show in shows" :key="show.id"
                                            v-slot="{ active, selected }" :value="show" as="template">
                                            <li
                                                :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900']">
                                                <div class="flex items-center">
                                                    <img v-if="show.logo" :src="show.logo"
                                                        class="w-5 h-5 mr-2 shrink-0">

                                                    <span :class="['block truncate', selected && 'font-semibold']">
                                                        {{
                                                        show.title
                                                        }} ({{ show.category }})
                                                    </span>
                                                    <span v-if="selected"
                                                        :class="['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600']">
                                                        <CheckIcon aria-hidden="true" class="w-5 h-5" />
                                                    </span>
                                                </div>

                                            </li>
                                        </ComboboxOption>
                                    </ComboboxOptions>
                                </div>
                            </Combobox>
                        </div>
                        <div class="col-span-4 sm:col-span-1">
                            <label class="block text-sm font-medium text-gray-700" for="type">Type <span
                                    class="text-red-600">*</span></label>
                            <SaCombobox id="type" v-model="credit.type" :options="showTypeOptions" name="type" />
                        </div>
                        <div class="col-span-4 sm:col-span-1">
                            <label class="block text-sm font-medium text-gray-700" for="role">Role <span
                                    class="text-red-600">*</span></label>
                            <input id="role" v-model="credit.role"
                                class="block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="role" type="text">

                        </div>
                        <div class="col-span-4 sm:col-span-2">
                            <label class="block text-sm font-medium text-gray-700" for="companyName">Organization <span
                                    class="text-red-600">*</span></label>

                            <Combobox v-model="selectedCompany" as="div" nullable>
                                <div class="relative mt-1">
                                    <ComboboxInput :display-value="displaySelectedCompany"
                                                   id="companyName"
                                        class="w-full py-2 pl-3 pr-10 bg-white border rounded-md shadow-sm border-clay-500 focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm"
                                        @change="getCompanies" />
                                    <ComboboxButton
                                        class="absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden" aria-label="Expand Button">
                                        <ChevronDownIcon aria-hidden="true" class="w-5 h-5 text-gray-400" />
                                    </ComboboxButton>
                                    <ComboboxOptions
                                        class="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm">

                                        <ComboboxOption v-if="queryCompany" v-slot="{ active, selected }"
                                            :value="queryCompany" as="template">
                                            <li
                                                :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900']">
                                                <span :class="['block truncate', selected && 'font-semibold']">
                                                    Add "{{ companyQuery }}"
                                                </span>
                                                <span v-if="selected"
                                                    :class="['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600']">
                                                    <CheckIcon aria-hidden="true" class="w-5 h-5" />
                                                </span>
                                            </li>
                                        </ComboboxOption>
                                        <ComboboxOption v-for="company in companies" :key="company.id"
                                            v-slot="{ active, selected }" :value="company" as="template">
                                            <li
                                                :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900']">

                                                <div class="flex items-center">
                                                    <img v-if="company.logo" :src="company.logo"
                                                        class="w-5 h-5 mr-2 shrink-0">

                                                    <span :class="['block truncate', selected && 'font-semibold']">
                                                        {{ company.name }} {{ company.address ? `(${company.address})` :
                                                        '' }}
                                                    </span>
                                                    <span v-if="selected"
                                                        :class="['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600']">
                                                        <CheckIcon aria-hidden="true" class="w-5 h-5" />
                                                    </span>
                                                </div>
                                            </li>
                                        </ComboboxOption>
                                    </ComboboxOptions>
                                </div>
                            </Combobox>
                        </div>
                        <div class="col-span-4 sm:col-span-1">
                            <label class="block text-sm font-medium text-gray-700" for="dateYear">Year</label>
                            <input id="dateYear" v-model="credit.dateYear"
                                class="block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="dateYear" type="number" min="1950">

                        </div>
                        <div class="col-span-4 sm:col-span-1">
                            <label class="block text-sm font-medium text-gray-700" for="director">Director</label>
                            <input id="director" v-model="credit.director"
                                class="block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm"
                                name="director" type="text">
                        </div>
                    </div>
                    <div class="py-3 mt-4 text-center">
                        <SaButton @click.prevent="submit" :loading="isSubmitting" variant="primary">
                            <template #loading>
                                Adding...
                            </template>
                            Add
                        </SaButton>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="mt-10">
        <div class="mt-4 space-y-1 sm:mt-10">
            <h3 class="text-xl font-bold leading-6 text-gray-900">Your Credits</h3>
            <p class="max-w-2xl text-sm text-clay-800">Drag/drop your credits listed below to adjust the display order on your profile.</p>
        </div>
        <div class="mt-6 space-y-4 ">
            <draggable v-model="credits" :options="{handle:'.handle'}" item-key="id" @change="sortCredits">
                <template #item="{element}">
                    <div class="px-6 py-4 border-b sm:grid md:grid-cols-8 bg-clay-50">
                        <div class="py-2 sm:col-span-1">
                            <ListBulletIcon aria-hidden="true" class="w-5 h-5 text-gray-400 handle" />
                        </div>
                        <div class="py-2 sm:col-span-3">
                            <span class="text-sm font-medium text-gray-900">{{ element.showName }}</span>
                            <span class="text-xs text-clay-800"> ({{ element.type }})</span>
                            <span v-if="element.dateYear" class="text-sm text-clay-800">, {{ element.dateYear }}</span>
                        </div>
                        <div class="py-2 text-sm font-medium sm:col-span-1">
                            {{ element.role }}
                        </div>
                        <div class="py-2 text-sm text-clay-800 sm:col-span-2">
                            {{ element.organizationName }}<span v-if="element.director">, {{ element.director }}</span>
                        </div>
                        <div aria-hidden="true" class="hidden py-2 text-right sm:col-span-1">
                            <Switch v-model="element.isFeatured"
                                :class="[element.isFeatured ? 'bg-clay-600' : 'bg-gray-200', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500']"
                                v-on:click.prevent="toggleIsFeatured(element)">
                                <span class="sr-only">Feature on profile?</span>
                                <span
                                    :class="[element.isFeatured ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200']"
                                    aria-hidden="true" />
                            </Switch>
                        </div>
                        <div class="py-2 text-left sm:col-span-1 sm:text-right">
                            <a class="text-xs text-clay-600 hover:text-clay-900" @click.prevent="deleteCredit(element)">
                                <TrashIcon class="w-5 h-5 text-red-300 sm:float-right hover:text-red-500" />
                            </a>
                        </div>
                    </div>
                </template>
            </draggable>

        </div>
    </div>

    <NotificationSuccess :show="updateSuccessful" content="Your changes were successfully saved."
        title="Successfully saved!" />

</template>

<script lang="ts" setup>
// @ts-ignore

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import draggable from 'vuedraggable';
import {
    AddExperience,
    DeleteExperience,
    ExperienceDTO,
    GetExperiences,
    GetExperiencesResponse, SearchGuidesByCategory, SearchGuidesByCategoryResponse, ShowDto,
    SortExperiences, TheatreCompanyDTO,
    ToggleExperienceIsFeatured
} from "@/dtos";
// @ts-ignore
import {CheckIcon, ChevronDownIcon, TrashIcon, ListBulletIcon} from '@heroicons/vue/20/solid';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SaCombobox from "@/main/components/SaCombobox.vue";
import {Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Switch} from '@headlessui/vue';
import _ from "lodash";
import {trackEvent} from '@/shared';
import SaButton from "@/main/components/SaButton.vue";

let responseStatus = ref(null);
let credit = ref({});
let credits: Ref<ExperienceDTO[]> = ref([]);
let updateSuccessful: Ref<Boolean> = ref(false);

let shows: Ref<ShowDto> = ref([]);
const selectedShow = ref({});
const query = ref('');

const queryShow = computed(() => {
    return query.value === '' || query.value.length < 3 ? null : {id: null, title: query.value}
});

const getShows = async (event: any) => {
    query.value = event.target.value;
    if (query.value !== '' && query.value.length >= 3) {
        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: query.value,
            category: 'Shows'}
        ))
            .then(res => {
                shows.value = res.results;
            });
    }
};

const displaySelectedShow = (selectedShow: any) => {
    let display = '';

    if (selectedShow.title) {
        if (selectedShow.category) {
            display = `${selectedShow.title} (${selectedShow.category})`;
        } else {
            display = `${selectedShow.title}`;
        }
    }
    return display;
};

let companies = ref([]);
const selectedCompany = ref({});
const companyQuery = ref('');


const queryCompany = computed(() => {
    return companyQuery.value === '' || companyQuery.value.length < 3 ? null : {id: null, name: companyQuery.value}
});

const getCompanies = async (event: any) => {
    companyQuery.value = event.target.value;
    if (companyQuery.value !== '' && companyQuery.value.length >= 3) {
        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: companyQuery.value,
            category: 'Companies'
        }))
            .then(res => {
                //companies.value = res.results;
                if(res.results){
                    let results = res.results.map((company: any) => {
                        return {
                            name: company.name,
                            id: company.id,
                            logo: company.logoUrl,
                            address: company.shortAddressPrettified
                        }
                    });
                    _.merge(companies.value, results);   
                }
            });

        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
            q: companyQuery.value,
            category: 'College Programs'
        }))
            .then(res => {
                if(res.results){
                    let results = res.results.map((program: any) => {
                        return {
                            name: program.programName,
                            id: program.id,
                            logo: program.logoUrl,
                            address: program.displayAddress
                        }
                    });
                    _.merge(companies.value, results);
                }
            });
    }
};

const displaySelectedCompany = (selectedCompany: any) => {
    let display = '';

    if (selectedCompany.name) {
        if (selectedCompany.shortAddressPrettified) {
            display = `${selectedCompany.name} (${selectedCompany.shortAddressPrettified})`;
        } else {
            display = `${selectedCompany.name}`;
        }
    }
    return display;
};


const showTypeOptions = ref([
    'Stage',
    'Television',
    'Film',
    'Modeling',
    'Dance',
    'Voice-Over',
    'Web Series',
    'Other'
]);

onMounted(async () => {
    await getExperiences();
});

const getExperiences = async () => {
    await client.get<GetExperiencesResponse>(new GetExperiences())
        .then(response => {
            credits.value = response.credits;
        });
}

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    responseStatus.value = null;

    let request = credit.value;
    if (selectedShow.value && selectedShow.value.title) {
        request.showName = selectedShow.value.title;
        request.showId = selectedShow.value.id;
    } else {
        request.showName = ''
    }
    if (selectedCompany.value && selectedCompany.value.name) {
        request.companyName = selectedCompany.value.name;
        request.companyId = selectedCompany.value.id;
    } else {
        request.companyName = '';
    }
    await client.post<GetExperiencesResponse>(new AddExperience(request))
        .then(async (res) => {
            credit.value = {};
            selectedShow.value = {};
            selectedCompany.value = {};
            updateSuccessful.value = true;
            responseStatus.value = null;
            credits.value = res.credits;

            trackEvent( 'profile_updated', {
                method: 'credit_added'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};

const toggleIsFeatured = async (credit: ExperienceDTO) => {
    await client.post<ResponseStatus>(new ToggleExperienceIsFeatured({
        id: credit.id,
        isFeatured: !credit.isFeatured
    }))
        .then(async () => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            credit.isFeatured = !credit.isFeatured;
        })
}

const deleteCredit = async (credit: ExperienceDTO) => {
    await client.post<ResponseStatus>(new DeleteExperience({id: credit.id}))
        .then(async () => {
            await getExperiences();
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
}

const sortCredits = async () => {
    let request = {
        ids: credits.value.map((c: ExperienceDTO) => c.id)
    };
    await client.post<ResponseStatus>(new SortExperiences(request))
        .then(async () => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
}

</script>
<style>

</style>